module.exports = __webpack_public_path__ + "static/Salary Finance-faa10796535f131697370085a921bdcf.jpg";